"use strict";
var logo = document.querySelector(".logo");
var body = document.querySelector("body");
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        return reject(new Error("Promise rejected!"));
    }, 3000);
});
var handlerSuccess = function() {
    var message = document.createElement("div");
    message.textContent = "Promise was resolved!";
    message.classList.add("message");
    body.appendChild(message);
};
var handlerError = function() {
    var message = document.createElement("div");
    message.textContent = "Promise was rejected!";
    message.classList.add("message", "error-message");
    body.appendChild(message);
};
promise1.then(handlerSuccess);
promise1.catch(handlerError);
promise2.then(handlerSuccess);
promise2.catch(handlerError);

//# sourceMappingURL=index.2ed1852e.js.map
